import React from "react";
import PropTypes from "prop-types";

const XAxisPixel = ({ isLoggedIn, gender, age }) => {
	if (!isLoggedIn || !gender || !age) {
		return null;
	}

	return (
		<img
			src={`//gmtdmp.mookie1.com/tagr/v1/activity?acid=2&inst=NA&tagid=54516519&src.rand=${Math.round(Math.random() * 10000)}&trb.clientID=133&trb.activityID=6927&src.Gender=${gender}&src.Age=${age}`}
			style={{ display: "none" }}
			alt=""
		/>
	);
};

XAxisPixel.propTypes = {
	isLoggedIn: PropTypes.bool.isRequired,
	gender: PropTypes.number,
	age: PropTypes.number,
};

XAxisPixel.defaultProps = {
	gender: null,
	age: null,
};

export default React.memo(XAxisPixel);



// WEBPACK FOOTER //
// ./src/routers/shared/components/XAxisPixel.jsx